import React from "react"
import PropTypes from "prop-types"
import {Link, withRouter} from 'react-router-dom';
import {Button, Col, FormControl, FormGroup, Glyphicon, Row} from "react-bootstrap"
import {TableHeaderColumn} from "react-bootstrap-table"
import BaseGrid from "../BaseGrid"
import FormButtons from "../form/FormButtons"
import {createOptions, Date, Enums, Grid} from "../../utils"
import {EventTypeLabel, ExpireStatus, ExpireStatusLabel} from "../../utils/enums";
import {formatEventDescription, getEventExpirationClassName} from "../../utils/format";
import EventForm, {createEventInitialValues} from "./EventForm";

class Events extends BaseGrid {

	constructor(props) {
		super(props);

		this.state = {
			...this.state,
			itemModalOpen: false,
			eventId: null,
			dog: null,
			action: null,
			actionModalOpen: null,
			actionItems: []
		};

		this.formatUser = this.formatUser.bind(this);
		this.formatAnimal = this.formatAnimal.bind(this);
		this.formatActions = this.formatActions.bind(this);

		this.handleItemModalClick = this.handleItemModalClick.bind(this);
		this.handleItemModalDismiss = this.handleItemModalDismiss.bind(this);

		this.handleActionSelect = this.handleActionSelect.bind(this);
		this.handleActionSubmit = this.handleActionSubmit.bind(this);
		this.handleRowSelect = this.handleRowSelect.bind(this);
		this.handleRowSelectAll = this.handleRowSelectAll.bind(this);

		this.handleActionModalDismiss = this.handleActionModalDismiss.bind(this);
	}

	getDefaultFilter() {
		return {
			"dogId": null,
			"eventTypes": [],
			"expireStatus": ExpireStatus.PENDING,

			"search": "",
			"orderCol": "eventDate",
			"orderDir": "a",
			"start": 0,
			"rows": this.getDefaultPageRows()
		}
	}

	componentWillMount() {
		this.props.onFetchEnums(['dog', 'dogAll', 'vaccine', 'methodExt', 'methodInt']);
		super.componentWillMount();
	}

	handleRowSelect({eventId}, isSelected) {
		const {actionItems} = this.state;
		if (isSelected) {
			this.setState({
				actionItems: [...actionItems, eventId].sort()
			});
		} else {
			this.setState({actionItems: actionItems.filter(it => it !== eventId)});
		}
		return false;
	}

	handleRowSelectAll(isSelected) {
		const {items} = this.props;
		if (!isSelected) {
			this.setState({actionItems: []})
		} else {
			const actionItems = [];
			for (let i = 0; i < items.length; i++) {
				actionItems.push(items[i].eventId)
			}
			this.setState({actionItems: actionItems})
		}
	}

	handleActionSelect(action) {
		this.setState({action: action})
	}

	handleActionSubmit() {
		const {actionItems, action} = this.state;
		if (!actionItems || !actionItems.length || !action || !action.value) {
			return
		}

		this.setState({actionModalOpen: true})
	}

	handleActionModalDismiss() {
		this.setState({actionModalOpen: false})
	}

	renderActionModal() {
		// const {session} = this.props;
		const {actionModalOpen, actionItems} = this.state;
		if (!actionModalOpen) {
			return null
		}
		const {items} = this.props;
		const selected = [];
		if (items && items.length) {
			for (let i = 0; i < items.length; i++) {
				if (actionItems.indexOf(items[i].eventId) >= 0) {
					selected.push(items[i])
				}
			}
		}
	}

	handleItemModalClick(eventId) {
		const {filter: {dogId}} = this.state;
		if (!eventId && dogId) {
			this.props.onLoadDog(dogId).then((json) => {
				this.setState({itemModalOpen: true, eventId, dog: json.response.data})
			});
		} else {
			this.setState({itemModalOpen: true, eventId, dog: null})
		}
	}

	handleItemModalDismiss() {
		this.setState({itemModalOpen: false, eventId: null, dog: null})
	}

	renderItemModal() {
		const {session} = this.props;
		const {itemModalOpen, eventId, filter: {dogId}, dog} = this.state;
		if (!itemModalOpen) {
			return null
		}

		const modal = {
			onHide: this.handleItemModalDismiss,
			onSuccess: (item) => {
				this.props.onFetchEnums(['dogAll']);
				this.handleInputChange({name: 'dogId', value: item.dogId}, true);
			}
		};

		return <EventForm event={createEventInitialValues(eventId, dogId, session, dog)} modal={modal}/>
	}

	formatDate(cell) {
		return Date.formatDate(cell);
	}

	formatType(cell) {
		return EventTypeLabel[cell];
	}

	formatUser(cell) {
		const {enums} = this.props;
		return Enums.getEnumTitle(enums, 'user', cell)
	}

	formatAnimal(cell) {
		const {enums} = this.props;
		return <Link to={{pathname: "/psi/" + cell}} className="btn">{Enums.getEnumTitle(enums, 'dogAll', cell)}</Link>
	}

	formatExpiration(cell, row) {
		if (row.expireFrom && row.expireFrom !== row.expireTo) {
			return <div>{Date.format(row.expireFrom, "DD.MM.YY")}<br/>{Date.format(row.expireTo, "DD.MM.YY")}</div>;
		} else {
			return Date.format(row.expireTo, "DD.MM.YY");
		}
	}

	formatExpireStatus(cell) {
		return cell ? ExpireStatusLabel[cell] : null;
	}

	formatActions(cell) {
		return <span>
			<Button bsStyle={'link'} onClick={() => this.handleItemModalClick(cell)}><Glyphicon glyph="pencil"/></Button>
		</span>
	}

	formatRow(row) {
		return getEventExpirationClassName(row);
	}

	getFilter() {
		const {enums} = this.props;
		const {filter} = this.state;

		const expireStatuses = createOptions(ExpireStatusLabel);

		return [
			<Row key="1">
				<Col xs={2}>
					<FormGroup>
						<FormControl type="text" value={filter.search} name="search" placeholder="Jméno, číslo" onChange={this.handleInputChange}/>
					</FormGroup>
				</Col>
				<Col xs={2}>
					{Grid.renderSelect("dogId", 'Všechna zvířata', filter.dogId, Enums.createEnumItems(enums, 'dogAll', true), this.handleSelectChange, true)}
				</Col>
				<Col xs={4}>
					{Grid.renderSelect("eventTypes", 'Všechny typy', filter.eventTypes, createOptions(EventTypeLabel), this.handleSelectChange, false, true)}
				</Col>
				<Col xs={4}>
					<Row>
						<Col xs={7}>
							<FormButtons currentValue={filter.expireStatus} options={expireStatuses} name="expireStatus" onInputChange={this.handleInputChange}/>
						</Col>
						{Grid.renderFilterButtons(this.onFilterReset, 5)}
					</Row>
				</Col>
			</Row>];
	}

	getCols() {
		const {enums} = this.props;
		return [
			<TableHeaderColumn key="eventId" dataField="eventId" width='5%' dataAlign="center" dataSort={true}>#</TableHeaderColumn>,
			<TableHeaderColumn key="eventAt" dataField="eventDate" width='8%' dataAlign="center" dataFormat={this.formatDate} dataSort={true}>Datum</TableHeaderColumn>,
			<TableHeaderColumn key="expireTo" dataField="expireTo" width='8%' dataAlign="center" dataFormat={this.formatExpiration} dataSort={true}>Expirace</TableHeaderColumn>,
			<TableHeaderColumn key="expireStatus" dataField="expireStatus" width='8%' dataAlign="center" dataFormat={this.formatExpireStatus} dataSort={true}>Stav</TableHeaderColumn>,
			<TableHeaderColumn key="eventType" dataField="eventType" width='13%' dataAlign="center" dataFormat={this.formatType} dataSort={true}>Typ</TableHeaderColumn>,
			<TableHeaderColumn key="dogId" dataField="dogId" width='9%' dataAlign="center" dataFormat={this.formatAnimal} dataSort={true}>Zvíře</TableHeaderColumn>,
			<TableHeaderColumn key="description" dataField="eventId" width='30%' dataAlign="center" dataFormat={(_, r) => formatEventDescription(r, enums, false)}>Popis</TableHeaderColumn>,
			<TableHeaderColumn key="eventDoctor" dataField="eventDoctor" width='10%' dataAlign="center" dataSort={true}>Lékař</TableHeaderColumn>,
			<TableHeaderColumn key="eventBy" dataField="eventBy" width='10%' dataAlign="center" dataFormat={this.formatUser} dataSort={true}>Provedl</TableHeaderColumn>,
			<TableHeaderColumn key="actions" dataField="eventId" width='6%' dataAlign="center" dataFormat={this.formatActions}>&nbsp;</TableHeaderColumn>
		]
	}

	render() {
		const {isFetchingItems, items, count, filter} = this.props;

		const actions = null;

		const actionCtx = {
			onActionSelect: this.handleActionSelect,
			onActionSubmit: this.handleActionSubmit,
			value: this.state.action,
			key: 'eventId',
			selectRowProp: {
				mode: 'checkbox',
				clickToSelect: true,
				onSelect: this.handleRowSelect,
				onSelectAll: this.handleRowSelectAll,
				selected: this.state.actionItems,
				bgColor: function (row, isSelect) {
					if (isSelect) {
						return "#fcf8e3"
					}
					return null;
				},
				unselectable: []
			},
			actions: actions
		};

		return <div>
			{filter.dogId && <Button className={'grid-new-button'} bsStyle={'success'} onClick={() => this.handleItemModalClick(null)}><Glyphicon glyph="plus"/> Nový úkon</Button>}
			{Grid.renderFull(isFetchingItems, items, count,
				Grid.getTableOptions(filter, this.onPageChange, this.onSortChange, this.onFilterChange, this.renderPaginationShowsTotal),
				this.getCols(),
				this.getFilter(),
				this.onFilterChange,
				actionCtx, this.formatRow)}
			{this.renderActionModal()}
			{this.renderItemModal()}
		</div>
	}
}

Events.propTypes = {
	...BaseGrid.propTypes,
	onLoadDog: PropTypes.func.isRequired,
	onFetchEnums: PropTypes.func.isRequired,
	enums: PropTypes.object.isRequired,
};

export default withRouter(Events)



// WEBPACK FOOTER //
// ./src/components/event/Events.js